<template>
  <div class="c-shutdown g-container">
    <Spin v-if="show" size="large" fix />
    <div class="module-content" ref="container">
      <moduler name="dmpadd" :title="title">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">人员消耗配置</span>
          </Col>
          <Col span="18">
            <edit-table
              :table-data="personalTableData"
              :manager-list="managerData"
              :middle-game-list="middleGameList"
              :platform-data="platformData"
              :edit="editState"
              @on-copy="copyRow"
              @on-delete="deleteRow"
            ></edit-table>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">任务触发规则</span>
          </Col>
          <Col span="1.5">
            <span class="item-field">实际总消耗</span>
          </Col>
          <Col span="8">
            <span class="item-field"> &gt;= </span>
            <input-number-plus
              v-model="sumAmountPercent"
              :max="3"
              :min="0"
              :maxNum="100"
              :precision="2"
              :width="80"
              placeholder="0-100.00"
            ></input-number-plus>
            <span class="item-field" style="margin-left: 10px">% 设定的消耗值</span>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" style="margin-top: 0">
          <Col span="3" class="col-item"> </Col>
          <Col span="1.5">
            <span class="item-field">创角总ROI</span>
          </Col>
          <Col span="8">
            <span class="item-field"> &lt;= </span>
            <input-number-plus
              v-model="roi"
              :max="3"
              :min="0"
              :maxNum="100"
              :precision="2"
              :width="80"
              placeholder="0-100.00"
            ></input-number-plus>
            <span class="item-field" style="margin-left: 10px">% </span>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">计划新建时间</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="planMonth" type="button">
              <Radio :label="1">1个月以内</Radio>
              <Radio :label="3">3个月以内</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">计划关停条件</span>
          </Col>
          <Col span="2">
            <span class="item-field">新创角付费数</span>
          </Col>
          <Col span="8">
            <span class="item-field"> &lt;= </span>
            <input-number-plus
              v-model="condiNewPayUserNum"
              :max="4"
              :min="0"
              :maxNum="9999"
              :precision="0"
              :width="80"
              placeholder="0-9999"
            ></input-number-plus>
            <span class="item-field" style="margin-left: 10px">个</span>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" style="margin-top: 0">
          <Col span="3" class="col-item"> </Col>
          <Col span="2">
            <span class="item-field">新创角付费金额</span>
          </Col>
          <Col span="8">
            <span class="item-field"> &lt;= </span>
            <input-number-plus
              v-model="condiNewRoleMoney"
              :max="6"
              :min="0"
              :maxNum="1000000"
              :precision="2"
              :width="80"
              placeholder="0-999999.99"
            ></input-number-plus>
            <span class="item-field" style="margin-left: 10px">元 </span>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" style="margin: 0">
          <Col span="3" class="col-item"> </Col>
          <Col span="2">
            <span class="item-field">计划流水</span>
          </Col>
          <Col span="8">
            <span class="item-field"> &lt;= </span>
            <input-number-plus
              v-model="condiSumMoney"
              :max="6"
              :min="0"
              :maxNum="1000000"
              :precision="2"
              :width="80"
              placeholder="0-999999.99"
            ></input-number-plus>
            <span class="item-field" style="margin-left: 10px">元 </span>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" style="margin-top: 0">
          <Col span="3" class="col-item"> </Col>
          <Col span="3">
            <span style="color: #ff4400; margin-top: 6px; display: block">注意：以上条件同时满足才触发</span>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">数据时间</span>
          </Col>
          <Col span="6">
            <RadioGroup v-model="dataTime" type="button">
              <Radio :label="1">当日实时</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">监控频率</span>
          </Col>
          <Col span="6">
            <RadioGroup v-model="moniFrequency" type="button">
              <Radio :label="10">每10分钟</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">提醒方式</span>
          </Col>
          <Col span="6">
            <RadioGroup v-model="alertType" type="button">
              <Radio :label="1">钉钉</Radio>
              <Radio :label="2">邮件</Radio>
              <Radio :label="3">钉钉 + 邮件</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">提醒人员</span>
          </Col>
          <Col span="6">
            <el-select
              v-model="alertOpIds"
              placeholder="请选择人员"
              style="width: 200px"
              size="small"
              filterable
              multiple
              clearable
              collapse-tags
            >
              <el-option v-for="item in operatorData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
            <span style="color: #ff4400; margin-top: 6px; display: block; position: absolute"
              >注意：默认配置了消耗监控的人员自动添加提醒，这里设置组长及相关提醒人</span
            >
          </Col>
        </Row>
      </moduler>
    </div>
    <!-- 按钮 -->
    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []" />
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button @click.stop="cannel">取消</Button>
          <Button type="primary" v-if="editState" :loading="loading" @click.stop="submit(0)">
            <span v-if="!loading">更新</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submit(1)">
            <span v-if="!loading">提交</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import { isArray, timeout } from '@/common/js/utils'
import validMixin from '../mixins/valid-mixin'
import { HOST_API } from '@/api/config'

import Moduler from '@/components/moduler.vue'
import ErrorPop from '@/components/error-pop.vue'
import editTable from '@/components/edit-table/edit-table.vue'

import { adPtom, getMiddleGameList, getSysMember } from '@/api/common.model'
import { addConsumeManage, updateConsumeManage, getConsumeManage } from '@/api/manage.model'
import InputNumberPlus from '@/components/input/input-number-plus'
export default {
  name: 'stAdd',
  mixins: [validMixin],
  components: { Moduler, ErrorPop, editTable, InputNumberPlus },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    title() {
      return this.editState ? '编辑人员消耗管控任务' : '创建人员消耗管控任务'
    }
  },
  data() {
    return {
      loading: null,
      show: null,
      formErr: null,
      errRes: [],
      platformData: [],
      managerData: [], // 带权限人员
      operatorData: [], // 不带权限人员
      middleGameList: [],
      sumAmountPercent: '', // 实际总消耗
      roi: '', // 创角总roi
      planMonth: 1, // 广告新建时间
      condiNewPayUserNum: '', // 新创角付费数
      condiNewRoleMoney: '', // 新创角付费金额
      condiSumMoney: '', // 广告计划流水
      alertOpIds: [], // 提醒人员
      alertType: 1, // 提醒方式
      dataTime: 1, // 数据时间（前端自定义，写死不提交）
      moniFrequency: 10, // 监控频率（前端自定义，写死不提交）
      personalTableData: [
        {
          managerId: '',
          mediaId: '',
          mgameId: '',
          platform: '',
          mondayVal: 0,
          tuesdayVal: 0,
          wednesdayVal: 0,
          thursdayVal: 0,
          fridayVal: 0,
          saturdayVal: 0,
          sundayVal: 0
        }
      ]
    }
  },
  methods: {
    valid() {
      const rules = [
        {
          name: 'sumAmountPercent',
          require: true,
          desc: '实际总消耗'
        },
        {
          name: 'roi',
          require: true,
          desc: '创角总ROI'
        },
        {
          name: 'condiNewPayUserNum',
          require: true,
          desc: '新创角付费数'
        },
        {
          name: 'condiNewRoleMoney',
          require: true,
          desc: '新创角付费金额'
        },
        {
          name: 'condiSumMoney',
          require: true,
          desc: '计划流水'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    submit(bool) {
      this.errRes = [...this.valid()]

      // 人员消耗配置校验
      const emptyIds = []
      const repeatIds = []
      this.personalTableData.forEach((ret, index) => {
        if (!ret.managerId || !ret.mediaId || !ret.mgameId || !ret.platform) emptyIds.push(index + 1)
        else {
          this.personalTableData.forEach((r, i) => {
            if (
              ret.managerId === r.managerId &&
              ret.mediaId === r.mediaId &&
              ret.mgameId === r.mgameId &&
              ret.platform === r.platform &&
              i !== index
            ) {
              repeatIds.push(index + 1, i + 1)
            }
          })
        }
      })
      const deRepeatIds = Array.from(new Set(repeatIds)).sort((n1, n2) => n1 - n2) // 去重 排序
      if (emptyIds.length) {
        this.errRes.push({
          feild: '人员消耗配置',
          msg: `请检查表格序号：【${emptyIds.join('，')}】, 姓名、媒体、中间件游戏、平台不能为空！`
        })
      }
      if (deRepeatIds.length > 1) {
        this.errRes.push({
          feild: '人员消耗配置',
          msg: `请检查表格序号：【${deRepeatIds.join('，')}】, 姓名、媒体、中间件游戏、平台不能重复！`
        })
      }

      if (this.errRes.length) {
        this.formErr = true
        return
      }

      this.personalTableData.forEach((ret) => delete ret._X_ROW_KEY)

      const params = {
        config: this.personalTableData,
        sumAmountPercent: this.sumAmountPercent ? this.sumAmountPercent / 100 : 0,
        roi: this.roi ? this.roi / 100 : 0,
        condiNewPayUserNum: this.condiNewPayUserNum,
        condiNewRoleMoney: this.condiNewRoleMoney,
        condiSumMoney: this.condiSumMoney,
        alertOpIds: this.alertOpIds.join(','),
        alertType: this.alertType,
        planMonth: this.planMonth
      }

      this.loading = true
      if (bool) {
        // 新增
        addConsumeManage(params)
          .then((data) => {
            if (typeof data !== 'symbol') this.loading = false
            if (data) {
              if (data.failCnt) {
                this.$Modal.confirm({
                  content: `任务新增成功${data.insertCnt}条，失败${data.failCnt}条`,
                  title: '提交结果',
                  okText: '下载失败数据',
                  cancelText: '知道了',
                  onOk: () => {
                    window.open(`${HOST_API}/api/ptom/consumeManage/downloadImportResult?requestId=${data.requestId}`, '_blank')
                    // 表格序号问题，刷新表格
                    this.copyRow(this.personalTableData[0])
                    this.deleteRow(this.personalTableData.length - 1)
                  },
                  onCancel: () => {
                    this.jump()
                  }
                })
              } else {
                this.$Modal.info({
                  content: `任务新增成功${data.insertCnt}条，失败${data.failCnt}条`,
                  title: '提交结果',
                  okText: '知道了',
                  onOk: () => {
                    this.jump()
                  }
                })
              }
            }
          })
          .catch((err) => {
            this.$Message.error(err)
          })
      } else {
        // 更新
        const { ruleId } = this.$route.query
        // 修改提交格式，抽出config
        const {
          managerId,
          mediaId,
          mgameId,
          platform,
          mondayVal,
          tuesdayVal,
          wednesdayVal,
          thursdayVal,
          fridayVal,
          saturdayVal,
          sundayVal
        } = params.config[0]
        Object.assign(params, {
          ruleId: Number(ruleId),
          managerId,
          mediaId,
          mgameId,
          platform,
          mondayVal,
          tuesdayVal,
          wednesdayVal,
          thursdayVal,
          fridayVal,
          saturdayVal,
          sundayVal
        })
        delete params.config

        updateConsumeManage(params)
          .then((data) => {
            if (typeof data !== 'symbol') this.loading = false
            if (data) {
              this.$Message.success({
                closable: true,
                duration: 1.5,
                content: '提交成功！2秒后自动跳转'
              })
              timeout(2000).then(() => {
                this.jump()
              })
            }
          })
          .catch((err) => {
            this.$Message.error(err)
          })
      }
    },
    cannel() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>关闭当前页面编辑信息将丢失，是否确定？</p>',
        onOk: () => {
          this.jump()
        }
      })
    },
    jump() {
      this.$router.push({ name: 'personalcontrollist' })
    },
    copyRow(row) {
      const { managerId, mediaId, mgameId, platform, mondayVal, tuesdayVal, wednesdayVal, thursdayVal, fridayVal, saturdayVal, sundayVal } =
        row
      if (this.personalTableData.length < 100) {
        this.personalTableData.push({
          managerId,
          mediaId,
          mgameId,
          platform,
          mondayVal,
          tuesdayVal,
          wednesdayVal,
          thursdayVal,
          fridayVal,
          saturdayVal,
          sundayVal
        })
      } else this.$Message.error('每次最多添加100条人员配置')
    },
    deleteRow(index) {
      this.personalTableData.splice(index, 1)
    },
    getData(ruleId) {
      this.show = true
      getConsumeManage({ ruleId }).then((data) => {
        const {
          managerId,
          mediaId,
          mgameId,
          platform,
          mondayVal,
          tuesdayVal,
          wednesdayVal,
          thursdayVal,
          fridayVal,
          saturdayVal,
          sundayVal,
          sumAmountPercent,
          roi,
          planMonth,
          condiNewPayUserNum,
          condiNewRoleMoney,
          condiSumMoney,
          alertOpIds,
          alertType
        } = data
        this.personalTableData = [
          {
            managerId,
            mediaId,
            mgameId,
            platform,
            mondayVal,
            tuesdayVal,
            wednesdayVal,
            thursdayVal,
            fridayVal,
            saturdayVal,
            sundayVal
          }
        ]
        this.sumAmountPercent = sumAmountPercent ? (sumAmountPercent * 100).toFixed(2) : 0
        this.roi = roi ? (roi * 100).toFixed(2) : 0
        this.planMonth = planMonth
        this.condiNewPayUserNum = condiNewPayUserNum
        this.condiNewRoleMoney = condiNewRoleMoney
        this.condiSumMoney = condiSumMoney
        this.alertOpIds = alertOpIds ? alertOpIds.split(',').map(Number) : []
        this.alertType = alertType
        this.show = false
      })
    },
    preloadData() {
      Promise.all([adPtom({ authFlag: 1 }), getMiddleGameList(), getSysMember()]).then((data) => {
        const [managerData, middleGameList, operatorData] = data
        this.platformData = [
          { id: 1, name: '安卓' },
          { id: 2, name: 'iOS' }
        ]
        isArray(managerData) && (this.managerData = managerData)
        isArray(middleGameList) && (this.middleGameList = middleGameList)
        isArray(operatorData) && (this.operatorData = operatorData)
      })
      const { ruleId } = this.$route.query
      if (ruleId) this.getData(ruleId)
    }
  },
  created() {
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-shutdown {
  overflow: auto;
  height: calc(100vh - 160px);

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      .ivu-btn {
        margin-right: 0;
        margin-left: 20px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

/* 必填项 */
::v-deep .row-item-must {
  position: relative;
  z-index: 5;

  &:after {
    content: ' ';
    display: inline-block;
    width: 4px;
    height: 4px;
    position: absolute;
    top: 6px;
    right: 0;
    background-color: #f45858;
    border-radius: 3px;
  }

  /* 单选框覆盖 */
}

::v-deep .ivu-radio-wrapper {
  min-width: 94px;
  text-align: center;
  user-select: none;
}
</style>
